/* Nova PDP – buy section: frame toggle + style strip drive one buy panel. See sections/nova-pdp.liquid */
(function () {
  var FRAME_LABEL = { black: 'Black frame', brown: 'Brown frame' };
  var FRAME_COLOUR = { black: '#1c1c1c', brown: '#5b3a29' };

  // Match the panel card to the photo's backdrop (same idea as the hero card).
  function sampleBg(src, done) {
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = 40; c.height = 40;
        var x = c.getContext('2d');
        x.drawImage(probe, 0, 0, 40, 40);
        var pts = [[1, 1], [38, 1], [1, 38], [38, 38]], r = 0, g = 0, b = 0;
        pts.forEach(function (p) { var d = x.getImageData(p[0], p[1], 1, 1).data; r += d[0]; g += d[1]; b += d[2]; });
        done('rgb(' + Math.round(r / 4) + ',' + Math.round(g / 4) + ',' + Math.round(b / 4) + ')');
      } catch (e) { /* cross-origin blocked: keep the default card colour */ }
    };
    probe.src = src.replace(/([?&])width=\d+/, '$1width=80');
  }

  function init(section) {
    if (section.dataset.nvShopReady) return;
    section.dataset.nvShopReady = '1';

    var tiles = [].slice.call(section.querySelectorAll('[data-nv-shop-tile]'));
    if (!tiles.length) return;
    var frameBtns = section.querySelectorAll('[data-nv-frame]');
    var stage = section.querySelector('.nv-shop__stage');
    var img = section.querySelector('[data-nv-shop-img]');
    var nameEl = section.querySelector('[data-nv-shop-name]');
    var frameEl = section.querySelector('[data-nv-shop-frame]');
    var dotEl = section.querySelector('[data-nv-shop-dot]');
    var priceEl = section.querySelector('[data-nv-shop-price]');
    var statusEl = section.querySelector('[data-nv-shop-status]');
    var idInput = section.querySelector('[data-nv-shop-id]');
    var addBtn = section.querySelector('[data-nv-shop-add]');
    var viewLink = section.querySelector('[data-nv-shop-view]');

    var frame = section.dataset.frame || 'black';
    var selected = tiles.filter(function (t) { return t.classList.contains('is-selected'); })[0] || tiles[0];

    function render() {
      var d = selected.dataset;
      var has = !!d[frame + 'Id'];
      var use = has ? frame : 'black';           // e.g. BGWC only comes with a black frame
      var id = d[use + 'Id'];
      var ok = d[use + 'Available'] === 'true';
      var src = d[use + 'Img'];

      nameEl.textContent = d.name;
      frameEl.textContent = has ? FRAME_LABEL[use] : FRAME_LABEL.black + ' (only frame for this style)';
      dotEl.style.setProperty('--sw', FRAME_COLOUR[use]);
      priceEl.textContent = (d[use + 'Price'] || '').replace(/&amp;/g, '&');
      statusEl.textContent = ok ? 'Available' : 'Sold out right now';
      statusEl.className = 'nv-shop__status ' + (ok ? 'is-in' : 'is-out');
      idInput.value = id;
      addBtn.disabled = !ok;
      addBtn.textContent = ok ? 'Add to bag' : 'Sold out';
      viewLink.href = d.url + '?variant=' + id;
      viewLink.textContent = d.current === 'true' ? 'View this board' : 'View details';

      // palette glow follows the selected style
      section.style.setProperty('--c1', selected.style.getPropertyValue('--c1'));
      section.style.setProperty('--c2', selected.style.getPropertyValue('--c2'));

      if (src && img.dataset.want !== src) {
        img.dataset.want = src;
        img.classList.add('is-swapping');
        var next = new Image();
        next.onload = next.onerror = function () {
          if (img.dataset.want !== src) return;   // a newer selection won the race
          img.src = src;
          img.alt = d.name + ', ' + FRAME_LABEL[use].toLowerCase();
          img.dataset.src = src;
          requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
        };
        next.src = src;
        sampleBg(src, function (c) { stage.style.setProperty('--shop-bg', c); });
      }
    }

    function setFrame(f) {
      frame = f;
      section.dataset.frame = f;
      frameBtns.forEach(function (b) {
        var on = b.dataset.nvFrame === f;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      render();
    }

    function select(tile) {
      selected = tile;
      tiles.forEach(function (t) {
        var on = t === tile;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      render();
    }

    frameBtns.forEach(function (b) { b.addEventListener('click', function () { setFrame(b.dataset.nvFrame); }); });
    tiles.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });

    // Keep the selected tile in view on narrow screens
    selected.scrollIntoView && section.querySelector('.nv-shop__strip').scrollTo({ left: Math.max(0, selected.offsetLeft - 16), behavior: 'auto' });
    render();
  }

  function boot(scope) { scope.querySelectorAll('[data-nv-shop]').forEach(init); }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
